// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__30n6w","notes":"Notes_notes__md-lK","note":"Notes_note__3Owh9","markdown":"Notes_markdown__1VJS4"};